import { useDocumentListingLazyQuery } from 'generated/graphql';
import React, { useState } from 'react';

export const usePDFDownload = () => {
  const [noAttachment, setNoAttachment] = useState(false);
  const [loadPDF, { loading }] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!!DocumentListing[0]?.fileURL || DocumentListing?.length > 0) {
        var a = document.createElement('a');
        a.setAttribute('href', DocumentListing[0]?.fileURL);
        a.setAttribute('type', 'application/pdf');
        a.setAttribute('download', 'download');
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        setNoAttachment(true);
      }
    },
  });

  const handleDownloadClick = (refID, claim?) => {
    loadPDF({
      variables: {
        refID: refID,
        description:
          claim === 'c_contractClaim' || claim === 'c_subcontractClaim'
            ? 'approved_document_pdf'
            : 'document_pdf',
      },
    });
  };

  const handleDownloadClickPDF = refID => {
    loadPDF({ variables: { refID: refID, description: 'document_pdf' } });
  };

  const handleDownloadClickPC = refID => {
    loadPDF({ variables: { refID: refID } });
  };

  return {
    handleDownloadClick,
    handleDownloadClickPDF,
    handleDownloadClickPC,
    noAttachment,
    setNoAttachment,
    pdfLoading: loading,
  };
};
